import { Component, ElementRef, ViewChild, AfterViewInit, input, output } from '@angular/core';
import { ModalInterface, Modal } from 'flowbite';
import { ButtonSecondaryComponent } from '../button-secondary/button-secondary.component';
import { ButtonPrimaryComponent } from '../button-primary/button-primary.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'app-modal-dialog',
  standalone: true,
  imports: [ButtonSecondaryComponent, ButtonPrimaryComponent, SvgIconComponent, CommonModule, TooltipComponent],
  templateUrl: './modal-dialog.component.html',
  styles: ``
})
export class ModalDialogComponent implements AfterViewInit {
  public modal: ModalInterface | undefined;
  public isOpen = false;
  public closeButton = input(false);
  public icon = input<string>('');
  public title = input<string>('');
  public description = input<string>('');
  public buttonCancelLabel = input<string>('');
  public buttonConfirmLabel = input<string>('');
  public type = input<'info' | 'negative'>('info');
  public confirmClicked = output<void>();
  public cancelClicked = output<void>();

  @ViewChild('modalDialogTemplate') private modalRef: ElementRef | undefined;

  ngAfterViewInit() {
    const $targetEl = this.modalRef?.nativeElement;
    this.modal = new Modal($targetEl);
  }

  public open() {
    if (this.modal) {
      this.isOpen = true;
      this.modal.show();
    }
  }

  public close() {
    if (this.modal) {
      this.isOpen = false;
      this.modal.hide();
    }
  }

  public onCancelClicked() {
    this.cancelClicked.emit();
    this.close();
  }

  public onConfirmClicked() {
    this.confirmClicked.emit();
    this.close();
  }
}
